import { socialMediaUrls } from '../constant/user-setting-modal-resources';
import {
  validateEmailRegex,
  validatePhone,
  validateTimeLargerThanCurrentDate,
} from '../helpers/validate';

// function below only use for profile info that have both end data and start date
export const handleIsWorking = ({
  setIsWorking,
  handleSetState,
}: {
  event: any;
  setIsWorking: Function;
  handleSetState: Function;
}) => {
  setIsWorking((state: string) => {
    if (state === 'off') {
      handleSetState('endDate', '');
      return 'on';
    } else {
      return 'off';
    }
  });
};

// function below only use for profile info that have both end data and start date
export const handleValidateUserInfoHaveStartDateAndEndDate = ({
  state,
  skipCurrentDateCheck = false, // skip checking the selected date < current date, specified for study field
}: {
  state: any;
  skipCurrentDateCheck?: Boolean;
}):
  | 'notHaveStartDateButEndDate'
  | 'invalidTime'
  | 'largerThanCurrentDate'
  | 'valid' => {
  const { startDate: timeStart, endDate: timeEnd } = state;

  if (!timeStart && timeEnd) {
    return 'notHaveStartDateButEndDate';
  }

  if (
    !skipCurrentDateCheck &&
    ((!!timeStart && validateTimeLargerThanCurrentDate(timeStart)) ||
      (!!timeEnd && validateTimeLargerThanCurrentDate(timeEnd)))
  ) {
    return 'largerThanCurrentDate';
  }

  const timeStartParse = timeStart
    ? new Date(timeStart).getTime()
    : new Date().getTime();
  const timeEndParse = timeEnd
    ? new Date(timeEnd).getTime()
    : new Date().getTime();

  return timeStartParse - timeEndParse <= 0 ? 'valid' : 'invalidTime';
};

export const renderSubmitFormContent = (id: string) =>
  !id ? 'Thêm thông tin thành công.' : 'Cập nhật thông tin thành công.';

export const checkSocialLinkConvention = (
  link: string,
  socialNetwork: string
): boolean => {
  let result: boolean = false;
  if (!link) {
    return result;
  }

  socialMediaUrls.forEach(({ name, url }: { name: string; url: string }) => {
    if (name === socialNetwork) {
      const linkSlice = link.slice(0, url.length);
      result = linkSlice === url || linkSlice === url.slice(0, url.length - 1);
      return result;
    }
  });

  return result;
};

export const checkContactInfoConvention = (
  contactType: string,
  contactInfo: string
): boolean => {
  if (!contactInfo) return false;
  switch (contactType) {
    case 'workEmail':
      return validateEmailRegex(contactInfo) ? true : false;
    case 'personalEmail':
      return validateEmailRegex(contactInfo) ? true : false;
    case 'personalPhone':
      return contactInfo.length <= 11 &&
        contactInfo.length >= 10 &&
        validatePhone(contactInfo)
        ? true
        : false;
    case 'workPhone':
      return contactInfo.length <= 11 &&
        contactInfo.length >= 10 &&
        validatePhone(contactInfo)
        ? true
        : false;
    default:
      return false;
  }
};
